<template>
  <v-container>
    <v-layout
      justify-space-around
      fill-height
    >
      <v-flex xs12>
        <v-layout
          row
          wrap
          justify-center
        >
          <v-flex
            v-show="noticeForm.imgs.length > 0"
          >
            <v-container
              grid-list-md
              v-if="type !== 1"
            >
              <v-layout
                wrap
                row
              >
                <v-slide-y-transition
                  v-for="(image, key) in noticeForm.imgs"
                  :key="key"
                >
                  <div
                    class="box"
                  >
                    <div
                      class="image-circle"
                      :style="{ backgroundImage: 'url(' + getImage(image) + ')' }"
                    />
                    <div class="box2">
                      <v-btn
                        icon
                        color="primary"
                        @click="removeImage"
                      >
                        <v-icon>clear</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-slide-y-transition>
              </v-layout>
            </v-container>
            <v-container v-else>
              <v-layout warp>
                <v-flex
                  v-for="(image, key) in noticeForm.imgs"
                  :key="key"
                  xs12
                  md6
                >
                  <div
                    class="image-rec"
                    :style="{ backgroundImage: 'url(' + getImage(image) + ')' }"
                  />
                </v-flex>
                <v-flex
                  xs1
                  md1
                  d-flex
                >
                  <v-icon
                    color="black"
                    class="align-center"
                    @click="launchFilePicker"
                  >
                    mode_edit
                  </v-icon>
                </v-flex>
                <v-flex
                  xs1
                  md1
                  d-flex
                >
                  <v-icon
                    color="black"
                    class="align-center"
                    @click="removeImage"
                  >
                    delete
                  </v-icon>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          v-show="noticeForm.imgs.length === 0"
        >
          <v-flex
            xs12
            sm12
            md3
            lg2
          >
            <v-img
              left
              avatar
              :src="require('@/assets/panel/modals/'+this.modalImg)"
              style="height:80px; width:80px;"
            />
          </v-flex>
          <v-flex
            xs12
            sm12
            md9
            lg10
            style="margin-top:20px;"
          >
            <input
              ref="file"
              name="file"
              type="file"
              style="display:none"
              accept="image/jpeg, image/png"
              @change="onFileChange($event.target.name, $event.target.files,$event)"
            >
            <a
              @click="launchFilePicker"
              style="margin-top:20px;"
            >Agregar imagen de portada</a>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <error
      v-model="errors.maxExceeded.show"
      :text="errors.maxExceeded.message"
    />
    <error
      v-model="errors.wrongImage.show"
      :text="errors.wrongImage.message"
    />
  </v-container>
</template>

<script>
import error from "../../Dialogs/Error.vue";
export default {
  components: {
    error
  },
  props: ["value", "type"],
  data: () => ({
    imageData: "",
    noticeForm: {
      imgs: []
    },
    flags: {
      updateImage: true
    },
    errors: {
      maxExceeded: {
        show: false,
        message: ""
      },
      wrongImage: {
        show: false,
        message: ""
      }
    },
    modalImg:"porta.png",
    
  }),
  watch: {
    value() {
      if (this.value == null || this.value == []) {
        this.noticeForm = {
          imgs: [],
          images: []
        };
      }else{
        this.noticeForm = {
          imgs: this.value,
        };
      }
    }
  },
  methods: {
    getImage(image){
      console.log(image);
      if (typeof image === 'string'){
        return image
      }

      if (typeof image === 'object'){
        return image.miniObjUrl ? image.miniObjUrl : image.img
      }

      return ""
    },
    launchFilePicker () {
      this.$refs.file.click()
    },
    removeImage(){
      this.noticeForm.imgs = []
      this.$emit("input", []);
    },
    onFileChange (fieldName, fileList, event) {
      console.log(fieldName, fileList);
      var wrongFiles = [];
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
         this.toDataURL(file).then((result) => {
            this.imageData = result
            this.$emit("input", [{img: result}]);
        }).catch((error) => {
            wrongFiles.push(file.name);
        });
      }

      if (wrongFiles.length === 1) {
        this.errors.wrongImage = {
          show: true,
          message: `No fue posible procesar la siguiente imagen: ${wrongFiles[0]}`
        }
      } else if (wrongFiles.length > 1) {
        this.errors.wrongImage = {
          show: true,
          message: `No fue posible procesar las siguientes imágenes: [${wrongFiles.join(', ')}]`
        }
      }
      event.target.value = null;
    },
    toDataURL(file) {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
      });
    }
  }
};
</script>

<style scoped>

.m-round {
  border-radius: 50%;
}

.box {
  width: 150px;
  height: 150px;
  position: relative;
}

.image-circle{
  width: 150px !important;
  height: 150px !important;
  background: 50% no-repeat;
  background-size: cover;
  border-radius: 50%;
  position: absolute;
    box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.2);
}


.image-rec{
  width: 100% !important;
  height: 150px !important;
  background: 50% no-repeat;
  background-size: cover;
  border-radius: 10px;
  box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.2);
}
        
.box2 {
  z-index: 10;
}

.container {
  padding: 0px;
  margin-top: 10px;
}
</style>
